import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';
import { validateBase, validatePort } from './validations.js';

export const devCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('dev')
    .option('-s, --https', t('dev_command_def.option.https'))
    .option('--port <port>', t('dev_command_def.option.port'), validatePort)
    .addOption(
      new Option('--origin <url>', t('dev_command_def.option.origin'))
        .argParser(validateBase)
        .hideHelp()
    )
    .action(async (options, command) => {
      const { DevCommand } = await import('../components/DevCommand/index.js');
      const { renderCommand } = await import('./render-command.js');

      const { https = false, origin, port } = options;

      await renderCommand(
        command,
        services,
        <DevCommand https={https} origin={origin} port={port} />,
        {
          watchForModelChanges: true,
        }
      );
    });
};
